import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false;

import Axios from "axios";
Vue.prototype.$http = Axios;
Axios.defaults.baseURL = process.env.VUE_APP_BSDB_API;
Vue.prototype.$BSDB_API = process.env.VUE_APP_BSDB_API;

Vue.prototype.$emptyQuery = JSON.parse(JSON.stringify({
	Company: null,
	CompanySpan: {
		Current: true,
		Past: false
	},
	Country: [],
	CountrySpan: {
		Current: true,
		Seeking: false,
		Past: false
	},
	Function: [],
	FunctionSpan: {
		Current: true,
		Seeking: false,
		Past: false
	},
	Industry: [],
	IndustrySpan: {
		Current: true,
		Seeking: false,
		Past: false
	},
	Region: [],
	State: [],
	StateSpan: {
		Current: true,
		Seeking: false
	},
	Title: null,
	TitleSpan: {
		Current: true,
		Past: false,
	},
	Language: [],
	Gender: [],
	Compensation: [],
	Name: null,
}));

import buefy from 'buefy';
import 'buefy/dist/buefy.css';
Vue.use(buefy, {
	defaultIconPack: "fas",
});

import moment from "vue-moment";
Vue.use(moment);

import InfiniteLoading from 'vue-infinite-loading';

Vue.use(InfiniteLoading, {
	slots: {
		distance: 10,
		spinner: "spiral"
	},
	system: {
		throttleLimit: 2000
	}
});

import currency from "@/services/currency.ts";
Vue.use(currency);

//import "@/services/raygun.ts";

import '@/assets/css/global.scss';

new Vue({
	router,
	store,
	created() {
		Axios.interceptors.request.use(
			config => {
				const token = localStorage.getItem("AESC_AUTH_TOKEN");
				if (token) {
					config.headers["Authorization"] = "Bearer " + token;
				}
				return config;
			},
			err => {
				Promise.reject(err);
			});

		let refreshPromises: any[] = [];
		let refreshing = false;
		Axios.interceptors.response.use(resp => {
			return resp;
		}, async err => {
			console.log(err);
			if (err.response.status === 500) {
				this.$buefy.toast.open({
					message: "We ran into an unexpected issue! Please refresh your page and try again.",
					type: 'is-danger'
				});
				return Promise.reject(err);
			}
			else if (err.response.status === 504) {
				this.$buefy.toast.open({
					message: "The request took too long.",
					type: 'is-danger'
				});
				return Promise.reject(err);
			}
			else if (err.response.status === 404) {
				this.$buefy.toast.open({
					message: "A request was made to content that does not exist.",
					type: 'is-danger'
				});
				return Promise.reject(err);
			}
			else if (err.response.status === 401) {
				if (err.response.headers["token-expired"] == "true" && !refreshing) {
					refreshing = true;
					return await new Promise((resolve, reject) => {
						Axios.post("api/refresh", { refreshToken: localStorage.getItem("AESC_REFRESH_TOKEN"), authToken: localStorage.getItem("AESC_AUTH_TOKEN") }).then(async (resp) => {
							store.dispatch("refresh", resp.data);
							refreshing = false;
							resolve(Axios.request(err.config));
							refreshPromises = refreshPromises.map(async (config) => {
								return await Axios.request(config);
							});
						}).catch(e => {
							refreshing = false;
							window.location.href = process.env.VUE_APP_AESC_DOMAIN + "login?ReturnURL=" + process.env.VUE_APP_BSDB_DOMAIN;
							reject(e);
						});
					});

				}
				else {
					refreshPromises.push(err.config);
				}
			}
			else {
				this.$buefy.toast.open({
					message: "An uncaught error response happened.",
					type: 'is-danger'
				});
				return Promise.reject(err);
			}

			return Promise.reject(err);
		});
	},
	render: h => h(App)
}).$mount('#app')
